import React from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  Card,
  Input,
  Table,
  Button,
  Select,
  Col,
  Row,
  Tooltip,
} from "antd";
import Avatar from "./Avatar";
import MaterialIcon from "./MaterialIcon";
import "assets/app/listview.css";
import jMoment from "components/classes/Jmomen";

// import "react-contexify/dist/ReactContexify.min.css";
// import {ContextMenu, Item, Separator, IconFont, ContextMenuProvider} from "react-contexify";

@autobind
/**
 *
 */
export default class ListView extends React.PureComponent {
  static propTypes = {
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    extra: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    items: PropTypes.arrayOf(PropTypes.object),
    onSearch: PropTypes.func,
    menu: PropTypes.func,
    action: PropTypes.func,
    onClick: PropTypes.func,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    status: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    primaryText: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
    secondaryText: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string,
    ]),
    selected: PropTypes.arrayOf(PropTypes.number),
    avatar: PropTypes.oneOfType([
      PropTypes.oneOf(["circle", "square", true, false]),
      PropTypes.object,
    ]),
    pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    loading: PropTypes.bool,
    activeItem: PropTypes.number,
    style: PropTypes.object,
    rowKey: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    disabled: PropTypes.func,
    selectedAll: PropTypes.bool,
    searchValue: PropTypes.string,
    directDataSource: PropTypes.bool,
  };

  static defaultProps = {
    disabled: () => false,
    items: [],
    rowKey: "id",
    primaryText: "primaryText",
    secondaryText: "secondaryText",
    avatar: false,
    icon: false,
    pagination: false,
    loading: false,
    style: {},
    selectedAll: false,
    searchValue: "",
    directDataSource: false,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      searchValue: props.searchValue,
      selected: props.selected,
      selectedRows: [],
      questionnaire: "مرتب سازی براساس:",
    };
  }

  // /**
  //  * get selected item's ids
  //  * @return {Number[]}
  //  */
  // get selected() {
  //   return this.state.selected;
  // }

  /**
   *
   */
  componentDidMount() {
    $(".listview .ant-pagination")
      .prev(".ant-table")
      .height("calc(100% - 100px)");
  }

  /**
   *
   * @param {Object} np
   */
  componentWillReceiveProps(np) {
    if (!app._.isEqual(this.props.selected, np.selected)) {
      this.setState({ selected: np.selected });
    }

    if (!np.searchValue.equals(this.state.searchValue)) {
      this.setState({ searchValue: np.searchValue });
    }
  }

  /**
   *
   */
  componentDidUpdate() {
    $(".listview .ant-pagination")
      .prev(".ant-table")
      .height("calc(100% - 80px)");
  }

  /**
   * get selected item's ids
   * @return {Number[]}
   * @deprecated
   */
  @deprecate("Use 'selected()' instead")
  getSelected() {
    return this.state.selected;
  }

  /**
   * get selected item"s ids
   * @return {Number[]}
   */
  selected() {
    return this.state.selected;
  }

  /**
   * get selected item's ids
   * @return {Number[]}
   */
  selectedRows() {
    return this.state.selectedRows;
  }

  /**
   *
   * @param {String} [searchValue=""]
   */
  resetSearch(searchValue = "") {
    this.setState({ searchValue });
  }

  /**
   *
   * @param {Object} item
   * @return {String}
   * @private
   */
  _primaryText(item) {
    const primaryText = this.props.primaryText;

    if (String.isString(primaryText)) {
      return item[primaryText];
    }

    if (Function.isFunction(primaryText)) {
      return primaryText(item);
    }

    return primaryText
      .reduce((prev, cur) => {
        if (item[cur]) prev.push(item[cur]);

        return prev;
      }, [])
      .join(" ");
  }

  /**
   *
   * @param {Object} item
   * @return {String}
   * @private
   */
  _secondaryText(item) {
    const secondaryText = this.props.secondaryText;

    if (String.isString(secondaryText)) {
      return item[secondaryText];
    }

    if (Function.isFunction(secondaryText)) {
      return (
        <div>
          {this.props.component === "Bulletin" ? (
            <div>
              {secondaryText(item)} --- از تاریخ: (
              {jMoment(item.dateFrom, "YYYY-M-D ").format("jYYYY/jMM/jDD")}) ---
              تا تاریخ: (
              {jMoment(item.dateTo, "YYYY-M-D ").format("jYYYY/jMM/jDD")})
            </div>
          ) : (
            secondaryText(item)
          )}
        </div>
      );
    }

    return secondaryText
      .reduce((prev, cur) => {
        if (item[cur]) prev.push(item[cur]);

        return prev;
      }, [])
      .join(" ");
  }

  /**
   *
   * @param {Object} item
   * @return {String}
   * @private
   */
  _renderAvatarSrc(item) {
    const avatar = this.props.avatar;

    if (Object.isPlainObject(avatar)) {
      return avatar.render(item);
    }

    return item.avatar;
  }

  /**
   *
   * @param {Object} item
   * @return {String}
   * @private
   */
  _renderAvatarText(item) {
    const primaryText = this.props.primaryText;

    if (String.isString(primaryText)) {
      return primaryText;
    }

    if (Function.isFunction(primaryText)) {
      return primaryText(item);
    }

    return primaryText
      .reduce((prev, cur) => {
        if (item[cur]) prev.push(item[cur]);

        return prev;
      }, [])
      .join(" ");
  }

  /**
   *
   * @param {{icon: ?(String|Node)}} item
   * @return {Node}
   * @private
   */
  _renderIcon(item) {
    const icon = this.props.icon;

    if (icon) {
      if (Function.isFunction(icon)) {
        return icon(item);
      }

      if (String.isString(item.icon)) {
        return <MaterialIcon name={item.icon} />;
      }

      return item.icon;
    }

    return null;
  }

  /**
   *
   * @param {{icon: ?(String|Node)}} item
   * @return {Node|null}
   * @private
   */
  _renderStatus(item) {
    const status = this.props.status;

    if (status) {
      if (Function.isFunction(status)) {
        return status(item);
      }

      if (String.isString(item.status)) {
        return <MaterialIcon name={item.status} />;
      }

      return item.status;
    }

    return null;
  }

  /**
   *
   * @private
   * @return {Object[]}
   */
  get _columns() {
    const selected = this.state.selected;
    const { menu, action, avatar, icon, status, selectedAll } = this.props;

    const _columns = [
      {
        key: "item",
        title: (
          <div>
            <div
              className="left"
              style={{
                lineHeight: "28px",
              }}
            >
              {app.translate("main.Select Page")}
            </div>
            {selected && selectedAll && (
              <Button
                className="right"
                type={selected.indexOf(0) === 0 ? "primary" : "ghost"}
                onClick={() =>
                  this.setState({ selected: !selected.contains(0) ? [0] : [] })
                }
              >
                {app.translate("main.Select All")}
              </Button>
            )}
          </div>
        ),
        render: (item) => (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            {avatar ? (
              <Avatar
                src={this._renderAvatarSrc(item)}
                text={this._renderAvatarText(item)}
                shape={String.isString(avatar) ? avatar : "circle"}
              />
            ) : (
              icon && <div className="icon">{this._renderIcon(item)}</div>
            )}
            {status && <div className="status">{this._renderStatus(item)}</div>}
            <div>
              <div>{this._primaryText(item)}</div>
              <div style={{ color: "rgba(0,0,0,.5)" }}>
                {this._secondaryText(item)}
              </div>
            </div>
          </div>
        ),
      },
    ];

    if (menu) {
      _columns.push({
        key: "action",
        width: 24,
        render: (item) => {
          let _overlay = menu(item);

          if (_overlay) {
            return (
              <Dropdown
                overlay={_overlay}
                trigger={["click"]}
                onClick={(e) => e.stopPropagation()}
              >
                <a className="ant-dropdown-link">
                  <MaterialIcon
                    name="dots-vertical"
                    style={{
                      width: 24,
                      height: 24,
                      fontSize: 24,
                    }}
                  />
                </a>
              </Dropdown>
            );
          }
        },
      });
    } else if (action) {
      _columns.push({
        key: "action",
        width: 24,
        render: (item) => (
          <div onClick={(e) => e.stopPropagation()}>{action(item)}</div>
        ),
      });
    }

    return _columns;
  }

  /**
   *
   * @return {{onChange: Function, selectedRowKeys: Array}}
   * @private
   */
  get _rowSelection() {
    return {
      selectedRowKeys: this.state.selected,
      onChange: (selectedRowKeys, selectedRows) =>
        this.setState({
          // selected: selectedRowKeys.filter((key) => key !== 0),
          selected: selectedRowKeys.where("<>", 0),
          selectedRows: selectedRows,
        }),
      getCheckboxProps: (record) => ({
        disabled: this.props.disabled(record),
      }),
    };
  }

  /**
   *
   * @return {String}
   * @private
   */
  get _title() {
    const selected = this.state.selected;
    const { title, pagination } = this.props;

    if (selected) {
      const length = selected.length;

      if (length > 0) {
        return [
          title,
          " ",
          <small key={2}>{`(${
            selected.contains(0) ? pagination.total : length
          } ${app.translate("main.Selected")})`}</small>,
        ];
      }
    }

    return title;
  }

  /**
   *
   * @param {Object[]} items
   * @return {Object[]}
   */
  _renderItems(items) {
    const _items = [];

    if (items) {
      items.forEach((item) => {
        const _item = item;

        if (_item.children && app._.isEmpty(_item.children)) {
          delete _item["children"];
        }

        _items.push(
          Object.assign(
            {},
            _item,
            _item.children
              ? { children: this._renderItems(_item.children) }
              : {}
          )
        );
      });
    }

    return _items;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const searchValue = this.state.searchValue;
    const {
      extra,
      items,
      onSearch,
      activeItem,
      selected,
      pagination,
      onClick,
      disabled,
      loading,
      style,
      rowKey,
      onChange,
      directDataSource,
    } = this.props;
    const { questionnaire } = this.state;
    return (
      <Card
        title={this._title}
        extra={extra}
        className="listview"
        style={style}
      >
        {onSearch && this.props.component !== "Bulletin" && (
          <Row justify="center" align="center">
            <Col sm={this.props.filterDropDown ? 14 : 24}>
              <Input.Search
                placeholder={app.translate("main.Search")}
                value={searchValue}
                onChange={(event) =>
                  this.setState({ searchValue: event.target.value })
                }
                onSearch={onSearch}
                style={{
                  margin: 4,
                  width: "calc(100% - 16px)",
                }}
              />
            </Col>
            {this.props.filterDropDown && (
              <Tooltip
                placement="top"
                title={app.translate("مرتب سازی بر اساس")}
              >
                <Col sm={10}>
                  <div className="report-form-item">
                    {/* <span style={{ color: "red" }}>*</span> */}
                    {/* {app.translate("مرتب سازی")} : */}
                    <Select
                      onChange={(questionnaire) => {
                        this.setState({ questionnaire });
                        onChange(questionnaire);
                      }}
                      style={{
                        width: "100%",
                        direction: "rtl",
                      }}
                      // placeholder="مرتب سازی براساس"
                      value={questionnaire}
                    >
                      <Select.Option key={"1"} value={"orderByPersonnelId"}>
                        کد پرسنلی
                      </Select.Option>
                      <Select.Option key={"2"} value={"orderByFullName"}>
                        اسم و فامیل
                      </Select.Option>
                    </Select>
                  </div>
                </Col>{" "}
              </Tooltip>
            )}
          </Row>
        )}

        <Table
          size="middle"
          rowKey={rowKey}
          showHeader={!!selected}
          // pagination={pagination}
          pagination={
            pagination &&
            {
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: app.config.pagination.limits,
            }.$assign(pagination)
          }
          onRowClick={(record) => {
            if (onClick && !disabled(record)) {
              onClick(record);
            }
          }}
          rowSelection={selected ? this._rowSelection : undefined}
          columns={this._columns}
          rowClassName={(item) =>
            item.id === activeItem ? "ant-table-row-hover" : undefined
          }
          dataSource={directDataSource ? items : this._renderItems(items)}
          loading={loading}
          style={{
            margin: "0px 8px",
          }}
        />
      </Card>
    );
  }
}
